// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3uIHU","requiredAsterisk":"Info_requiredAsterisk__3mN8V"};